import { Component } from '@angular/core';

@Component({
  selector: 'elsi-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  standalone: false,
})
export class HomeComponent {}
